import React from "react";
import { motion } from "framer-motion";
import { CREATOR } from "@/constants/testIds";

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 1.05, ease: [0.22, 0.61, 0.36, 1], delay: i * 0.12 },
  }),
};

const AboutCreator = () => {
  return (
    <section
      id="about-creator"
      data-testid={CREATOR.section}
      className="relative w-full py-28 md:py-40 lg:py-48"
      style={{ background: "var(--soti-surface)" }}
    >
      <div className="absolute inset-x-0 top-0 h-px" style={{ background: "var(--soti-rule)" }} />
      <div className="absolute inset-x-0 bottom-0 h-px" style={{ background: "var(--soti-rule)" }} />

      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            custom={0}
            className="md:col-span-3"
          >
            <div className="flex md:flex-col items-start gap-4">
              <span className="rule rule-cinder" aria-hidden="true" />
              <p className="overline">The Creator</p>
            </div>
          </motion.div>

          <div className="md:col-span-9 max-w-2xl">
            <motion.h2
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              custom={1}
              data-testid={CREATOR.heading}
              className="font-display text-[#F3EFEA] text-4xl sm:text-5xl md:text-6xl leading-[1.04] tracking-[-0.02em]"
            >
              About the Creator
            </motion.h2>

            <motion.div
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              custom={2}
              data-testid={CREATOR.body}
              className="mt-10 space-y-7 text-[#D9D4CD] text-base sm:text-lg leading-relaxed font-light"
            >
              <p>
                <span className="font-display italic text-[#F3EFEA] text-xl sm:text-2xl pr-1">
                  Federico C. Quiñones
                </span>{" "}
                is the author and creator of{" "}
                <em className="font-display italic text-[#F3EFEA]">
                  Shadows of the Infinite: Echoes of Cinder
                </em>
                , the first book in a mythic science-fantasy saga built around
                war, memory, machines, relics, and cosmic erasure.
              </p>
              <p>
                A military veteran and longtime advocate for resilience and
                mental health, Federico began building the world of{" "}
                <em className="font-display italic text-[#F3EFEA]">
                  Shadows of the Infinite
                </em>{" "}
                as a private act of survival — a way to turn trauma, memory,
                and the fight to keep living into myth.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCreator;
